import {useCallback} from 'react';
import updateUserDoc from '../../api/user/updateUserDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useSetDisableAnimation() {
  const setDisableAnimationFn = useCallback(async (disableAnimation: boolean): Promise<void> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    await updateUserDoc(uid, {disableAnimation});
  }, []);

  const {loading, error, refetch} = useFunctionRun(setDisableAnimationFn, {
    skipLoadOnMount: true,
  });

  return {
    setDisableAnimation: refetch,
    loading,
    error,
  };
}
